import { Box, CircularProgress, IconButton, Typography, Button } from '@material-ui/core';
import React, { useMemo, useState } from 'react';
import { DeleteForever, Edit } from '@material-ui/icons';

import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu';
import DataTable from '../../../../components/DataTable';
import useListarV2, { LISTAR_FILTERS } from './useListarV2';
import { format } from 'date-fns';
import { producaov2 } from '../../../../services/apis';

const statusMapper = {
  0: 'Desativada',
  1: 'Ativa',
}

const statusColor = {
  0: "error",
  1: "success"
}

function ListarActions({ id, onDelete }) {
  const [loadingDelete, setLoadingDelete] = useState(false);

  async function deleteTrail() {
    const response = await swal({
      title: "Você tem certeza?",
      text: "Não será possível recuperar a trilha deletada",
      icon: "warning",
      dangerMode: true,
      buttons: ['Cancelar', 'Excluir trilha']
    });

    if (response) {
      setLoadingDelete(true);

      producaov2
        .delete(`incompany/v3/trails/${id}`)
        .then(res => {
          swal("Excluido!", "Sua trilha foi excluida com sucesso", "success");
          onDelete();
        })
        .catch(err => {
          swal("Aconteceu um erro!", err.toString(), "error");
        })
        .finally(() => {
          setLoadingDelete(false);
        });
    }

  }

  return (
    <Box>
      <IconButton title="Editar trilha" size="small" component="a" href={`/admin/trilhas/detalhes/${id}`} target="_blank">
        <Edit color="primary" />
      </IconButton>
      <IconButton title="Deletar trilha" size="small" onClick={deleteTrail}>
        {loadingDelete ? <CircularProgress size={16} /> : <DeleteForever color="error" />}
      </IconButton>
    </Box>
  )
}

export default function ListarTrilhasV2() {
  const {
    data,
    filters,
    isLoading,
    page,
    rowsPerPage,
    changePage,
    changeRowsPerPage,
    changeFilters,
    resetFilters,
    refreshData
  } = useListarV2();

  const rows = useMemo(() => {
    return data?.data?.map(row => {
      return {
        id: row?.id,
        title: row?.title,
        description: row?.description,
        status: row?.active,
        updated_at: format(new Date(row?.updated_at), 'dd/MM/yyyy'),
        actions: <ListarActions {...row} onDelete={refreshData} />
      }
    })
  }, [data]);

  return (
    <Box width="100%" paddingLeft="250px">
      <AdminMenu />
      <Box width="100%" padding="1rem">
        <DataTable
          showFilters
          showPagination
          maxHeight="70vh"
          hasStickHeader
          filters={[
            { key: LISTAR_FILTERS.SEARCH, name: 'Busca', component: { type: 'text' } }
          ]}
          columns={[
            { key: 'title', name: 'Título', isSingleLine: true, maxWidth: '300px' },
            { key: 'description', name: 'Descrição', isSingleLine: true, maxWidth: '300px' },
            { key: 'status', name: 'Status', renderCustomRow: (row) => statusMapper[row?.status] },
            { key: 'updated_at', name: 'Última atualização', isSingleLine: true },
            { key: 'actions', name: 'Ações', isSingleLine: true }
          ]}
          rows={rows}
          page={page}
          isLoading={isLoading}
          rowsPerPage={rowsPerPage}
          selectedFilters={filters}
          totalRecords={data?.paging?.total}
          onPageChange={changePage}
          onRowsPerChange={changeRowsPerPage}
          onSubmitFilters={changeFilters}
          onResetFilters={resetFilters}
          CustomToolbarElement={
            <Box
              width="100%"
              display="flex"
              alignItems="start"
              justifyContent="flex-start"
              style={{
                gap:"1rem"
              }}
            >
              <Typography variant="h5" component="h1">
                Listar Trilhas
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => window.open("/admin/trilhas/criar","_blank")}
              >
                Criar Trilha
              </Button>
            </Box>

          }
        />
      </Box>
    </Box>
  );
}